import React, { useState, useEffect } from "react";
import { TooltipsIcon } from "../../assets/icons";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { reqToUpdateSettings } from "../../redux/slices.js/settings/settingsSlice";

const EmailConfiguration = ({ settings = [] }) => {
  const dispatch = useDispatch();
  // Convert API settings array → object { name: value }
  const initialState = settings.reduce((acc, s) => {
    acc[s.name] = s.value;
    return acc;
  }, {});

  const [formValues, setFormValues] = useState({
    smtp_host: "",
    smtp_port: "",
    smtp_username: "",
    smtp_password: "",
    from_name: "",
    from_email: "",
    use_tls_ssl: false,
    ...initialState,
  });

  const handleChange = (field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleToggle = (field) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSaveChanges = () => {
    const payload = Object.entries(formValues).map(([name, value]) => ({
      name,
      value: value instanceof Date ? value.toISOString() : value,
    }));

    dispatch(
      reqToUpdateSettings({
        data: payload,
        onSuccess: (response) => {
          // any additional success logic here
        },
        onFailure: (error) => {
          console.error("Failed to update settings:", error);
          // any additional failure logic here
        },
      })
    );
  };

  const emailToggles = [{ id: "use_tls_ssl", label: "Use TLS/SSL" }];

  return (
    <>
      <div className="space-y-4">
        <div className="grid gap-4 md:gap-6 md:grid-cols-2">
          {[
            {
              name: "smtp_host",
              label: "SMTP Host",
              type: "text",
              placeholder: "smtp.gmail.com",
            },
            {
              name: "smtp_port",
              label: "SMTP Port",
              type: "number",
              placeholder: "587",
              icon: TooltipsIcon,
            },
            {
              name: "smtp_username",
              label: "SMTP Username",
              type: "text",
              placeholder: "noreply@monveta.com",
            },
            {
              name: "smtp_password",
              label: "SMTP Password",
              type: "text",
              placeholder: "noreply@monveta.com",
            },
            {
              name: "from_name",
              label: "From Name",
              type: "text",
              placeholder: "Monveta HR",
            },
            {
              name: "from_email",
              label: "From Email",
              type: "email",
              placeholder: "noreply@monveta.com",
            },
          ].map((field) => (
            <div className="form-group" key={field.name}>
              <label>
                {field.label} <span>*</span>
              </label>
              <div className={field.icon ? "relative" : ""}>
                <input
                  type={field.type}
                  placeholder={field.placeholder}
                  className={field.icon ? "pe-5" : ""}
                  value={formValues[field.name]}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                />
                {field.icon && (
                  <span className="absolute right-3 top-3 h-5 w-5 text-gray-500 pointer-events-none">
                    {field.icon}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="grid gap-4 md:gap-6 md:grid-cols-2">
          {emailToggles.map((toggle) => (
            <div
              key={toggle.id}
              className="flex items-center justify-start gap-4"
            >
              <button
                type="button"
                role="switch"
                aria-checked={formValues[toggle.id]}
                onClick={() => handleToggle(toggle.id)}
                className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                  formValues[toggle.id] ? "bg-[#4285F4]" : "bg-[#E5E7EB]"
                }`}
              >
                <span
                  aria-hidden="true"
                  className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                    formValues[toggle.id]
                      ? "translate-x-[10px]"
                      : "translate-x-0"
                  }`}
                />
              </button>
              <span className="text-black text-span">{toggle.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={`mt-auto flex gap-3 pt-6 justify-end flex-wrap`}>
        <button
          type="button"
          className="next-btn !text-[#0060FF] !bg-[#EEF4FF]"
        >
          Test Email Configuration
        </button>
        <button type="button" className="next-btn" onClick={handleSaveChanges}>
          Save Email Settings
        </button>
      </div>
    </>
  );
};

export default EmailConfiguration;
